export enum TOASTER_MESSAGES {
  CAMPAIGN_CREATED = 'toastrMessage.campaignCreated',
  CAMPAIGN_DEACTIVATED = 'toastrMessage.campaignDeactivated',
  CAMPAIGN_REACTIVATED = 'toastrMessage.campaignReactivated',
  BRAND_CREATED = 'toastrMessage.brandCreated',
  BRAND_CREATED_WITH_APPROVE = 'toastrMessage.brandCreatedWithApprove',
  BRAND_UPDATED = 'toastrMessage.brandUpdated',
  BRAND_DEACTIVATED = 'toastrMessage.brandDeactivated',
  BRAND_REACTIVATION_SUBMITTED = 'toastrMessage.brandReactivationSubmitted',
  APPROVE_BRAND = 'toastrMessage.approveBrand',
  REJECT_BRAND = 'toastrMessage.rejectBrand',
  UPDATE_TILE_SECTIONS = 'toastrMessage.updateTileSections',

  APPROVE_OFFER = 'toastrMessage.approveOffer',
  REJECT_OFFER = 'toastrMessage.rejectOffer',
  DELETE_OFFER = 'toastrMessage.deleteOffer',
  EXPIRED_OFFER = 'toastrMessage.expiredOffer',
  RECALL_OFFER = 'toastrMessage.recallOffer',

  OFFER_DRAFT_CREATED = 'toastrMessage.offerDraftCreated',
  OFFER_DRAFT_UPDATED = 'toastrMessage.offerDraftUpdated',
  OFFER_DRAFT_DELETED = 'toastrMessage.offerDraftDeleted',
  OFFER_SEND_FOR_APPROVAL = 'toastrMessage.offerSendForApproval',
  OFFERS_CREATED_AND_SENT_FOR_APPROVAL = 'toastrMessage.offersCreatedAndSentForApproval',

  IMAGE_WAS_CHANGED = 'toastrMessage.imageWasChanged',
  IMAGE_WAS_DELETED = 'toastrMessage.imageWasDeleted',

  APPROVE_ORGANIZATION = 'toastrMessage.approveOrganization',
  REJECT_ORGANIZATION = 'toastrMessage.rejectOrganization',

  USER_PROFILE_UPDATED = 'toastrMessage.userProfileUpdated',
  PASSWORD_CHANGED = 'toastrMessage.passwordChanged',

  ORGANIZATION_PROFILE_UPDATED = 'toastrMessage.organizationProfileUpdated',
  INVITE_USER_SUCCESS = 'toastrMessage.inviteUserSuccess',
  USER_ACTIVATED = 'toastrMessage.userActivated',
  USER_DEACTIVATED = 'toastrMessage.userDeactivated',
  USER_DELETED = 'toastrMessage.userDeleted',
  USER_ROLE_CHANGED = 'toastrMessage.userRoleChanged',

  FILE_UPLOADED = 'toastrMessage.fileUploaded',

  VENDOR_UPDATED = 'toastrMessage.vendorUpdated',

  ORGANIZATION_ACTIVATED = 'toastrMessage.organizationActivated',
  ORGANIZATION_DEACTIVATED = 'toastrMessage.organizationDeactivated',
  ORGANIZATION_CONFIGURED = 'toastrMessage.organizationConfigured',
  ORGANIZATION_RECONFIGURED = 'toastrMessage.organizationReconfigured',

  LOCATION_LINKED = 'toastrMessage.locationLinked',
  LOCATION_UNLINKED = 'toastrMessage.locationUnlinked',

  OFFER_CATEGORY_LINKED = 'toastrMessage.offerCategoryLinked',
  OFFER_CATEGORY_UNLINKED = 'toastrMessage.offerCategoryUnlinked',

  AUDIENCE_LINKED = 'toastrMessage.audienceLinked',
  AUDIENCE_UNLINKED = 'toastrMessage.audienceUnlinked',

  AMBASSADOR_CODE_DELETED = 'toastrMessage.ambassadorCodeDeleted',
  AMBASSADOR_CODE_EDITED = 'toastrMessage.ambassadorCodeEdited',
  AMBASSADOR_CODE_CREATED = 'toastrMessage.ambassadorCodeCreated',

  ASSIGN_AMBASSADOR = 'toastrMessage.assignAmbassador',
  UNASSIGN_AMBASSADOR = 'toastrMessage.unassignAmbassador',

  ORGANIZATION_NOW_PENDING_CONFIGURED = 'toastrMessage.organizationNowPendingConfigured',
  ORGANIZATION_NOW_PENDING_APPROVAL = 'toastrMessage.organizationNowPendingApproval',

  USER_PROFILE_IMAGE_UPDATED = 'toastrMessage.userProfileImageUpdated',
  USER_PROFILE_IMAGE_DELETED = 'toastrMessage.userProfileImageDeleted',

  ORGANIZATION_LOGO_IMAGE_UPDATED = 'toastrMessage.organizationLogoImageUpdated',
  ORGANIZATION_LOGO_IMAGE_DELETED = 'toastrMessage.organizationLogoImageDeleted',
  LOCATION_REQUEST_SEND = 'toastrMessage.locationRequestSend',

  LOCATION_APPROVED = 'toastrMessage.locationApproved',
  LOCATION_REJECTED = 'toastrMessage.locationRejected',

  LOCATION_ACTIVATED = 'toastrMessage.locationActivated',
  LOCATION_DEACTIVATED = 'toastrMessage.locationDeactivated',

  CREATE_LOCATION_REQUEST_CREATED = 'toastrMessage.locationCreated',
  EDIT_LOCATION_REQUEST_CREATED = 'toastrMessage.locationEdited',

  BRAND_EDIT_REQUEST_CREATED = 'toastrMessage.brandEditRequestCreated',

  CAMPAIGN_LANDING_CONFIG_SAVED = 'toastrMessage.campaignLandingConfigSaved',
  CAMPAIGN_LANDING_CONTENT_DELETED = 'toastrMessage.campaignLandingContentDeleted',
}
